import Store from './Store'
import storeShape from './shape'

export { Store as default, Store, storeShape }
